/* 
    Dynamically adjust the position of the navigation bar based on the window size
    and scroll position, making it more user-friendly and responsive.
    
    The code adds an event listener to the document object that listens for the 'DOMContentLoaded' event. 
    
    When this event is fired, it triggers an anonymous function that adds two more event listeners to the window object:
    - The first event listener listens for the 'DOMContentLoaded' event on the window object.
    - The second event listener listens for the 'resize' event on the window object.
    
    Both event listeners trigger the handleMenuPosition() function.
    The handleScroll() function calculates the height of the navigation bar using 
    document.getElementById('header_menu').offsetHeight. 
    If the window has been scrolled past the height of the navigation bar, it adds the 'fixed-top' class to the navigation bar 
    element using classList.add(). 
    It also adds padding to the top of the body element to prevent content from being hidden behind the navigation bar. 
    If the window has not been scrolled past the navigation bar, it removes the 'fixed-top' class from the navigation bar element using classList.remove(). 
    It also removes the padding from the top of the body element.
*/

document.addEventListener("DOMContentLoaded", function(){
    window.addEventListener('DOMContentLoaded', function() {
        handleMenuPosition();
    });
    window.addEventListener('resize', function() {
        handleMenuPosition();
    });
});

function handleMenuPosition() {
    if (window.matchMedia("(min-width: 992px)").matches) {
        window.addEventListener('scroll', handleScroll);
    }
    else {
        window.removeEventListener('scroll', handleScroll);
    };
};

function handleScroll() {
    navbar_height = document.getElementById('header_menu').offsetHeight;
    if (window.scrollY > navbar_height) {
        document.getElementById('header_menu').classList.add('fixed-top');
        // add padding top to show content behind navbar
        document.body.style.paddingTop = navbar_height + 'px';
    } else {
        document.getElementById('header_menu').classList.remove('fixed-top');
        // remove padding top from body
        document.body.style.paddingTop = '0';
    }
};
